import React, { useContext, useEffect, useState } from 'react'
import Draggable from "react-draggable";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import { ModalDialog } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import { addNewVersion, getVersionNumbering } from '../../services/versionHistoryService';
import { ThemeContext } from '../../layout/BaseLayout';
import moment from 'moment';
import { Loader } from '../../utils/loader';
import { hanldeSortingArray } from '../../utils/sortingByColumn';

const numbersDragModal = (props) => {
    return (
        <Draggable handle=".modal-header">
            <ModalDialog {...props} />
        </Draggable>
    );
};

const VersionNumbers = () => {

    let toast = useContext(ThemeContext);

    const blankObj = {
        "id": "",
        "type": "",
        "versionNumber": "",
        "releaseDate": "",
        "status": true
    }

    const [numbersModalShow, setNumbersModalShow] = useState(false);
    const [addNumbersData, setAddNumbersData] = useState({ ...blankObj });
    const [disableSubmitBtn, setDisableSubmitBtn] = useState(false);
    const [versionNumberingList, setVersionNumberingList] = useState([]);
    const [selectedArr, setSelectedArr] = useState([]);
    const [loader, setLoader] = useState(false);
    const [isEdit, setIsEdit] = useState(false);
    const [numbersAddError, setNumbersAddError] = useState({
        "typeError": false,
        "versionNumberError": false,
        "releaseDateError": false,
    })
    let defaultSortingOrderObj = {
        sortingOrder: 'asc',
        upDownArrowColumn: null,
        fieldType: null
    };
    const [sortingOrderObj, setSortingOrderObj] = useState({ ...defaultSortingOrderObj });

    const openVersionAddModal = () => {
        setNumbersModalShow(true);
        setAddNumbersData({ ...blankObj });
    }

    const closeNumbersModal = () => {
        setNumbersModalShow(false);
        setIsEdit(false);
    }

    const updateField = (fld, val) => {
        const dta = addNumbersData
        dta[fld] = val;
        setAddNumbersData({ ...dta })
    }

    const addNewVersionData = () => {
        setDisableSubmitBtn(true);
        if (!isEdit) {
            delete addNumbersData['id'];
        }
        addNewVersion(addNumbersData).then((res) => {
            setDisableSubmitBtn(false);
            if (res.isSuccess) {
                let tempNumbList = [...versionNumberingList];
                let index = versionNumberingList?.findIndex((itm) => itm.id === addNumbersData.id);
                tempNumbList[index] = res?.data;
                if (index !== -1) {
                    setVersionNumberingList([...tempNumbList]);
                } else {
                    setVersionNumberingList([...versionNumberingList, res.data])
                }
                setNumbersModalShow(false);
                setAddNumbersData({ ...blankObj })
                toast.success(res?.successMessage);
            } else {
                toast.error(res?.exception?.message);
            }
        })
    }

    const getVersions = () => {
        setLoader(true);
        getVersionNumbering().then((res) => {
            setLoader(false);
            if (res.isSuccess) {
                setVersionNumberingList(res.data);
            }
        }).catch(e => {
            setLoader(false);
        })
    }

    const editVersionNumberAddModal = (item) => {
        setIsEdit(true);
        setAddNumbersData({
            id: item.id || "",
            type: item.type || "",
            versionNumber: item.versionNumber || "",
            releaseDate: item.releaseDate || "",
            status: item.status,
        });
        setNumbersModalShow(true);
    }

    console.log(addNumbersData)

    const onSelectionRow = (item) => {
        if (!!versionNumberingList && versionNumberingList.length > 0) {
            const selectedRow = versionNumberingList.map((elem) => { return elem.id }).indexOf(item.id);
            if (selectedRow > -1) {
                setSelectedArr([versionNumberingList[selectedRow]]);
            }
        }
    }

    const checkItem = (item) => {
        const checkData = !!selectedArr && selectedArr.some((val) => val?.id === item?.id);
        return checkData;
    }

    const creatingSortingArrFn = (field, type) => {
        let order = sortingOrderObj.sortingOrder;
        if (field === sortingOrderObj.upDownArrowColumn) {
            order = order === 'asc' ? 'desc' : 'asc';
            setSelectedArr([]);
        } else {
            order = 'asc';
            setSelectedArr([]);
        }
        setSortingOrderObj({ sortingOrder: order, upDownArrowColumn: field, fieldType: type })
    }

    useEffect(() => {
        if (!!sortingOrderObj && sortingOrderObj.upDownArrowColumn !== '') {
            let sortedArrayByColumn = [...versionNumberingList]
            sortedArrayByColumn = hanldeSortingArray(sortedArrayByColumn, sortingOrderObj.upDownArrowColumn, sortingOrderObj.fieldType, sortingOrderObj.sortingOrder)
            setVersionNumberingList(sortedArrayByColumn);
        }
    }, [sortingOrderObj])


    useEffect(() => {
        getVersions();
    }, [])

    return (
        <div id='tabs'>
            {loader && <Loader />}
            <div className="maintitle-box">
                <div className="w-50 d-inline-block">
                    <h2 className="maintitle "><img className="main-title-img" src={"/images/svg/connectionencryptdescript.svg"} alt="" />Version Numbers</h2>
                </div>
                <div className="w-50 d-inline-block">
                    <div className="float-end ">
                        <div className="d-inline-block mr-3"><i id="feedModuleRefresh" className="fa fa-refresh font-size-14 remove_arrow_summary" onClick={() => { getVersions(); }}></i>
                        </div>
                        <button className="addnewbtn mb-0" onClick={() => { openVersionAddModal() }}>
                            <i className="fa-solid fa-circle-plus mr-2"></i>Add
                        </button>
                    </div>
                </div>
            </div>
            <div className="thead-fixed">
                <table className="table table-bordered table-strip w-100 mb-30 new-data-asc-desc">
                    <thead>
                        <tr className="thead-dard-bg">
                            <th className=" srn-width">Sr</th>
                            <th className={`feed-m-name sorting sorting_${sortingOrderObj.upDownArrowColumn === 'type' && sortingOrderObj.sortingOrder === 'asc' ? 'asc' : 'desc'}`} onClick={() => creatingSortingArrFn('type', 'Text')}>Type</th>
                            {/* <td className="w65-leverage">Secret Key</td> */}
                            <th className={`lic-domain sorting sorting_${sortingOrderObj.upDownArrowColumn === 'versionNumber' && sortingOrderObj.sortingOrder === 'asc' ? 'asc' : 'desc'}`} onClick={() => creatingSortingArrFn('versionNumber', 'Text')}>Version Number</th>
                            <th className={`sorting sorting_${sortingOrderObj.upDownArrowColumn === 'releaseDate' && sortingOrderObj.sortingOrder === 'asc' ? 'asc' : 'desc'}`} onClick={() => creatingSortingArrFn('releaseDate', 'Text')}>Release Date </th>
                            <th className={`lic-status sorting sorting_${sortingOrderObj.upDownArrowColumn === 'status' && sortingOrderObj.sortingOrder === 'asc' ? 'asc' : 'desc'}`} onClick={() => creatingSortingArrFn('status', 'Status')}>Status </th>
                        </tr>
                    </thead>
                    <tbody>
                        {!!versionNumberingList && versionNumberingList.length > 0 && versionNumberingList.map((item, i) => {
                            return (
                                <tr key={"versionNumber" + i} onDoubleClick={() => { editVersionNumberAddModal(item) }} onClick={() => onSelectionRow(item)}
                                    className={`${!item.status ? "text-pink" : ''} ${checkItem(item) ? 'selected-tr' : ''} `}>
                                    <td className="">{i + 1}</td>
                                    <td className="">{item.type}</td>
                                    <td className="">{item.versionNumber}</td>
                                    <td className="">{moment(new Date(item.releaseDate)).format("DD/MM/YYYY")}</td>
                                    <td className="">{item.status ? "Active" : "Inactive"}</td>
                                </tr>
                            )
                        })}
                    </tbody>
                </table>
            </div>
            <div className="login-popup">
                <Modal
                    className="login feed-modules"
                    show={numbersModalShow}
                    onHide={() => closeNumbersModal()}
                    backdrop="static"
                    dialogAs={numbersDragModal}
                    animation={false}
                    size="md"
                    centered
                >
                    <Modal.Header closeButton style={{ border: "none" }}>
                        <Modal.Title className="w-100">
                            Version Numbers
                            <div className="btn-help d-inline-block float-right ">
                            </div>
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body style={{ display: "flex", flexDirection: "column" }}>
                        <div>
                            <div className="fidderbox-inner office-feed-height">
                                <div className="">
                                    <table border="0" cellSpacing="0" cellPadding="0" className="w-100">
                                        <tbody>
                                            <tr>
                                                <td className="office-w80 font11 text-right font11 v-align-baseline">Type:</td>
                                                <td className={`feederw-430 loginUser ${numbersAddError.typeError && 'error'}`}>
                                                    <select
                                                        className="inputborder font11 w-100  ml-2 h20 mb-2"
                                                        value={addNumbersData.type}
                                                        onChange={(e) => updateField("type", e.target.value)}
                                                    >
                                                        <option value="">Select</option>
                                                        <option value="Admin">Admin</option>
                                                        <option value="Dealer">Dealer</option>
                                                    </select></td>
                                                <td className="feederw-100 font11 text-right font11">&nbsp;</td>
                                            </tr>
                                            <tr>
                                                <td className="office-w80 font11 text-right font11 v-align-baseline">Version Number:</td>
                                                <td className={`feederw-430 text-right false ${numbersAddError.versionNumberError && 'error'}`}>
                                                    <input
                                                        type="text"
                                                        className="inputborder font11 w-100  ml-2 h20 mb-2" name="versionNumber"
                                                        autocomplete='off'
                                                        value={addNumbersData.versionNumber}
                                                        onChange={(e) => { updateField("versionNumber", e.target.value); (e.target.value === '' ? setNumbersAddError({ ...numbersAddError, versionNumberError: true }) : setNumbersAddError({ ...numbersAddError, versionNumberError: false })) }}
                                                    /> </td>
                                                <td className="feederw-100 font11 text-right font11">&nbsp;</td>
                                            </tr>
                                            <tr>
                                                <td className="office-w80 font11 text-right font11 v-align-baseline">Realease Date:</td>
                                                <td className={`feederw-430 ${numbersAddError.releaseDateError && 'error'}`}>
                                                    <input
                                                        type="date"
                                                        className="inputborder font11 w-100  ml-2 h20 mb-2"
                                                        name="releaseDate"
                                                        value={addNumbersData.releaseDate ? moment(addNumbersData.releaseDate).format('YYYY-MM-DD') : ''}
                                                        onChange={(e) => { updateField("releaseDate", e.target.value) }}
                                                    /></td>
                                                <td className="feederw-100 font11 text-right font11">&nbsp;</td>
                                            </tr>
                                            <tr>
                                                <td className="symbolrw-150 text-right font11 ">Status:</td>
                                                <td colspan="2" className="symbolrw-430 officeuser-redio-feed">
                                                    <div className="form-check-inline width-50 mb-2 mr-4">
                                                        <label className="form-check-label marginleft25group">
                                                            <input
                                                                type="radio"
                                                                className="form-check-input mt-1"
                                                                name="numberStatus"
                                                                onChange={(e) => { updateField("status", true) }}
                                                                checked={addNumbersData.status}
                                                            />Yes
                                                        </label>
                                                    </div>
                                                    <div className="form-check-inline width-50">
                                                        <label className="form-check-label ml-3">
                                                            <input
                                                                type="radio"
                                                                className="form-check-input mt-1"
                                                                name="numberStatus"
                                                                onChange={(e) => { updateField("status", false) }}
                                                                checked={!addNumbersData.status}
                                                            />No
                                                        </label>
                                                    </div>
                                                </td>
                                                <td className="feederw-100 font11 text-right font11">&nbsp;</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <div>
                            <div className="w-100 text-right p-1">
                                <Button className="btnmain mr-3" onClick={() => { addNewVersionData() }} disabled={disableSubmitBtn}>
                                    {disableSubmitBtn && <i className="fa fa-spinner fa-spin mr-2"></i>}Submit
                                </Button>
                                <Button onClick={() => closeNumbersModal()} className="btnmain-danger">
                                    Cancel
                                </Button>
                            </div>
                        </div>
                    </Modal.Footer>
                </Modal>
            </div>
        </div>
    )
}

export default VersionNumbers